import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import callApi, { abortableCallApi } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_HCPCS_CODES = 'FETCH_HCPCS_CODES';
export const FETCH_HCPCS_CODES_SUCCESS = 'FETCH_HCPCS_CODES_SUCCESS';
export const FETCH_HCPCS_CODES_FAIL = 'FETCH_HCPCS_CODES_FAIL';
export const CLEAR_HCPCS_CODES = 'CLEAR_HCPCS_CODES';
export const CREATE_HCPCS_CODE = 'CREATE_HCPCS_CODE';
export const CREATE_HCPCS_CODE_SUCCESS = 'CREATE_HCPCS_CODE_SUCCESS';
export const CREATE_HCPCS_CODE_FAIL = 'CREATE_HCPCS_CODE_FAIL';
export const UPDATE_HCPCS_CODE = 'UPDATE_HCPCS_CODE';
export const UPDATE_HCPCS_CODE_SUCCESS = 'UPDATE_HCPCS_CODE_SUCCESS';
export const UPDATE_HCPCS_CODE_FAIL = 'UPDATE_HCPCS_CODE_FAIL';
export const DELETE_HCPCS_CODE = 'DELETE_HCPCS_CODE';
export const DELETE_HCPCS_CODE_SUCCESS = 'DELETE_HCPCS_CODE_SUCCESS';
export const DELETE_HCPCS_CODE_FAIL = 'DELETE_HCPCS_CODE_FAIL';

// Reducer
export default function hcpcsCodesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_HCPCS_CODES:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_HCPCS_CODES_SUCCESS: {
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          ...triggerLoading ? { loading: state.loading - 1 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_HCPCS_CODES_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_HCPCS_CODES:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case CREATE_HCPCS_CODE_SUCCESS: {
      const newData = [
        ...state.data.slice(0, state.data.length),
        payload,
      ];
      return {
        ...state,
        count: state.count + 1,
        data: newData,
      };
    }
    case UPDATE_HCPCS_CODE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_HCPCS_CODE_SUCCESS: {
      const index = state.data.findIndex(dataItem => dataItem.ID === payload.ID);
      const newData = [
        ...state.data.slice(0, index),
        ...state.data.slice(index + 1),
      ];
      return {
        ...state,
        count: state.count - 1,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchHCPCSCodes(payload) {
  return { type: FETCH_HCPCS_CODES, payload };
}

export function fetchHCPCSCodesSuccess(payload) {
  return { type: FETCH_HCPCS_CODES_SUCCESS, payload };
}

export function fetchHCPCSCodesFail(payload) {
  return { type: FETCH_HCPCS_CODES_FAIL, payload };
}

export function clearHCPCSCodes(payload) {
  return { type: CLEAR_HCPCS_CODES, payload };
}

export function createHCPCSCode(payload) {
  return { type: CREATE_HCPCS_CODE, payload };
}

export function createHCPCSCodeSuccess(payload) {
  return { type: CREATE_HCPCS_CODE_SUCCESS, payload };
}

export function createHCPCSCodeFail(payload) {
  return { type: CREATE_HCPCS_CODE_FAIL, payload };
}

export function updateHCPCSCode(payload) {
  return { type: UPDATE_HCPCS_CODE, payload };
}

export function updateHCPCSCodeSuccess(payload) {
  return { type: UPDATE_HCPCS_CODE_SUCCESS, payload };
}

export function updateHCPCSCodeFail(payload) {
  return { type: UPDATE_HCPCS_CODE_FAIL, payload };
}

export function deleteHCPCSCode(payload) {
  return { type: DELETE_HCPCS_CODE, payload };
}

export function deleteHCPCSCodeSuccess(payload) {
  return { type: DELETE_HCPCS_CODE_SUCCESS, payload };
}

export function deleteHCPCSCodeFail(payload) {
  return { type: DELETE_HCPCS_CODE_FAIL, payload };
}

// Requests

let abort;

export function requestFetchHCPCSCodes({ limit, offset }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi(`inventory/hcpc/?limit=${limit}&offset=${offset}`);
  abort = request.abort;
  return request.res;
}

export function requestSearchHCPCSCodes({ filters, limit, offset, show }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('inventory/hcpc/search/', 'POST', {
    ...filters ? { filters } : {},
    sort_by: [
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
    ...show ? { show } : {},
  });
  abort = request.abort;
  return request.res;
}

export function requestCreateHCPCSCode(payload) {
  return callApi('inventory/hcpc/', 'POST', payload);
}

export function requestUpdateHCPCSCode(payload) {
  return callApi('inventory/hcpc/', 'PATCH', payload);
}

export function requestDeleteHCPCSCode(payload) {
  return callApi(`inventory/hcpc/?id=${payload}`, 'DELETE');
}

export function requestCreateHCPCSCodePrice(payload) {
  return callApi('inventory/hcpc_code_price/', 'POST', payload);
}

export function requestUpdateHCPCSCodePrice(payload) {
  return callApi('inventory/hcpc_code_price/', 'PATCH', payload);
}

// Sagas
function* fetchHCPCSCodesSaga(action) {
  const { triggerLoading, filters, show } = action.payload;
  try {
    const res = filters || show
      ? yield call(requestSearchHCPCSCodes, action.payload)
      : yield call(requestFetchHCPCSCodes, action.payload);
    yield put(fetchHCPCSCodesSuccess({
      data: res.data,
      count: res.count,
      triggerLoading,
      ...action.payload.push ? { push: true } : {},
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchHCPCSCodesFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createHCPCSCodeSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateHCPCSCode, values);
    yield put(createHCPCSCodeSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New HCPCS Code successfully added',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createHCPCSCodeFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateHCPCSCodeSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    let res;
    let pricesRes;
    if (values['HCPC S Code Price']) {
      pricesRes = yield all(
        values['HCPC S Code Price'].map((item) => {
          if (item.ID) {
            delete item['Price Type'];
            return call(requestUpdateHCPCSCodePrice, item);
          } else {
            return call(requestCreateHCPCSCodePrice, {
              ...item,
              'HCPC S Code ID': values.ID,
            });
          }
        }),
      );

      yield put(fetchAccountInformationSuccess(pricesRes[0].user_info));
      yield put(fetchAppInfoSuccess(pricesRes[0].app_info));
    }
    delete values['HCPC S Code Price'];
    if (Object.keys(values).length > 1) {
      res = yield call(requestUpdateHCPCSCode, values);
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    }
    const mergedRes = {
      ID: values.ID,
      ...pricesRes ? {
        'HCPC S Code Price': pricesRes.map(item => item.data),
      } : {},
      ...res ? {
        ...res.data,
      } : {},
    };
    yield put(updateHCPCSCodeSuccess(mergedRes));
    
    yield put(addNotification({
      message: 'HCPCS Code successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(mergedRes);
    }
  } catch (err) {
    yield put(updateHCPCSCodeFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deleteHCPCSCodeSaga(action) {
  const { ID } = action.payload;
  try {
    const res = yield call(requestDeleteHCPCSCode, ID);
    yield put(deleteHCPCSCodeSuccess({ ID }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'HCPCS Code successfully deleted',
      variant: 'success',
    }));
  } catch (err) {
    yield put(deleteHCPCSCodeFail(err.data));
    yield put(addNotification({
      message: 'Failed to delete HCPCS Code',
      variant: 'warning',
    }));
  }
}

export function* hcpcsCodesSaga() {
  yield takeLatest(FETCH_HCPCS_CODES, fetchHCPCSCodesSaga);
  yield takeEvery(CREATE_HCPCS_CODE, createHCPCSCodeSaga);
  yield takeEvery(UPDATE_HCPCS_CODE, updateHCPCSCodeSaga);
  yield takeEvery(DELETE_HCPCS_CODE, deleteHCPCSCodeSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/hcpcsCodes.js